import { formatDisplayString } from "./format/display.js";
export function promptForSession(session, continuation = false) {
    if (continuation)
        return '... ';
    return `rdb:${groupDisplayName(session)}:${keyDisplayName(session)}> `;
}
function groupDisplayName(session) {
    var _a, _b;
    if (session.currentGroup === undefined)
        return '-';
    return (_b = (_a = session.workspace.roots.get(session.currentGroup)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : formatDisplayString(session, session.currentGroup, { role: 'hash' });
}
function keyDisplayName(session) {
    var _a, _b;
    const identity = session.selectedAuthor();
    if (identity === undefined)
        return '-';
    const label = (_b = (_a = session.keyVault) === null || _a === void 0 ? void 0 : _a.list().find((key) => key.keyId === identity.keyId)) === null || _b === void 0 ? void 0 : _b.label;
    return label !== null && label !== void 0 ? label : formatDisplayString(session, identity.keyId, { role: 'hash' });
}
